import type { EditableCallbackParams } from "ag-grid-enterprise";

type Props = EditableCallbackParams;

export const AttachmentNameColumn = ({ data }: Props) => {
	return data.FileName || "";
};
